// extracted by mini-css-extract-plugin
export var phone = "_4x-0";
export var phoneDragging = "_4x-1";